import { cn } from "./cn";

/** Whether a keystroke belongs to where it landed: a text field, an open dialog or sheet, or a menu. Page shortcuts skip these. */
export const ownsKeys = (t: EventTarget | null) =>
  t instanceof Element && ((t instanceof HTMLElement && t.isContentEditable) || !!t.closest("input,textarea,select,[role=dialog],[role=menu]"));

/** Keyboard keys, e.g. `<Kbd keys={["⌘", "K"]} />`. */
export function Kbd({ keys, className }: { keys: string | string[]; className?: string }) {
  const list = Array.isArray(keys) ? keys : [keys];
  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      {list.map((key) => (
        <kbd
          key={key}
          className="inline-grid h-5 min-w-5 place-items-center rounded-sm border border-line-strong border-b-2 bg-surface px-1 font-sans text-[11px] font-semibold leading-none text-ink-soft"
        >
          {key}
        </kbd>
      ))}
    </span>
  );
}
